import React from "react";
import { CustomIcon } from "../shared/CustomIcon";

// Quick actions bottom sheet for a tapped node card in the drilldown view.
export default function QuickActionsMenu({ node, isSuperAdmin, onClose, onLogFollowUp, onViewProfile, onReassign, onRemove }) {
  if (!node) return null;
  return (
    <div
      data-testid="quick-actions-menu"
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 210, display: "flex", alignItems: "flex-end", justifyContent: "center" }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ background: "var(--kc-surface)", border: "1px solid color-mix(in srgb, var(--kc-accent) 30%, transparent)", borderTopLeftRadius: 20, borderTopRightRadius: 20, width: "100%", maxWidth: 520, padding: "16px 16px calc(24px + env(safe-area-inset-bottom)) 16px" }}
      >
        <div style={{ width: 36, height: 4, background: "rgba(255,255,255,0.20)", borderRadius: 999, margin: "0 auto 14px" }} />
        <div style={{ fontFamily: "'Cinzel',serif", fontSize: 13, color: "var(--kc-accent)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10, fontWeight: 700 }}>
          {node.slotRef} · {node.levelName}{node.memberNumber ? ` · #${node.memberNumber}` : ""}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <button className="btn btn-outline btn-sm" data-testid="qa-log-followup" onClick={() => { onLogFollowUp && onLogFollowUp(node); onClose(); }} style={{ justifyContent: "flex-start", display: "flex", alignItems: "center", gap: 8 }}>
            <CustomIcon name="chat" size={14} /> Log Follow-Up
          </button>
          <button className="btn btn-outline btn-sm" data-testid="qa-view-profile" onClick={() => { onViewProfile && onViewProfile(node); onClose(); }} style={{ justifyContent: "flex-start", display: "flex", alignItems: "center", gap: 8 }}>
            <CustomIcon name="person" size={14} /> View Profile
          </button>
          {isSuperAdmin && (
            <>
              <button className="btn btn-outline btn-sm" data-testid="qa-reassign" onClick={() => { onReassign && onReassign(node); onClose(); }} style={{ justifyContent: "flex-start", display: "flex", alignItems: "center", gap: 8 }}>
                <CustomIcon name="arrow-right" size={14} /> Reassign
              </button>
              <button className="btn btn-sm" data-testid="qa-remove" onClick={() => { onRemove && onRemove(node); onClose(); }} style={{ background: "rgba(255,107,107,0.20)", color: "#ff6b6b", border: "1px solid rgba(255,107,107,0.40)", justifyContent: "flex-start", display: "flex", alignItems: "center", gap: 8 }}>
                <CustomIcon name="lock" size={14} /> Remove
              </button>
            </>
          )}
          <button className="btn btn-outline btn-sm" data-testid="qa-cancel" onClick={onClose} style={{ justifyContent: "center", marginTop: 4 }}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
